// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/styles/layout.css */

/* Main app layout: sidebar on left, header and main content on right */
body {
  overflow-y: auto;
  display: grid;
  grid-template-areas:
    "sidebar header"
    "sidebar main";
  grid-template-columns: 1fr 3fr;
  grid-template-rows: 1fr 8fr;
  gap: 2rem;
  padding: 1rem 3rem;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sidebar {
  grid-area: sidebar;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1rem;
}

/* Main content grid: hero section and insights + forecast below */
main {
  grid-area: main;
  display: grid;
  grid-template-areas:
    "hero extras"
    "forecast forecast";
  grid-template-rows: 2fr 1fr;
  grid-template-columns: 2fr minmax(280px, 1fr);
  gap: 1rem;
}

.weather-hero {
  grid-area: hero;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

/* Secondary insights panel (wind + astronomy modules) */
.insight-cards {
  grid-area: extras;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0 1rem;
}

/* Bottom forecast panel */
.forecast {
  grid-area: forecast;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
`, "",{"version":3,"sources":["webpack://./src/styles/layout.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B,uEAAuE;AACvE;EACE,gBAAgB;EAChB,aAAa;EACb;;kBAEgB;EAChB,8BAA8B;EAC9B,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;AACf;;AAEA,kEAAkE;AAClE;EACE,eAAe;EACf,aAAa;EACb;;uBAEqB;EACrB,2BAA2B;EAC3B,6CAA6C;EAC7C,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA,wDAAwD;AACxD;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC","sourcesContent":["/* src/styles/layout.css */\n\n/* Main app layout: sidebar on left, header and main content on right */\nbody {\n  overflow-y: auto;\n  display: grid;\n  grid-template-areas:\n    \"sidebar header\"\n    \"sidebar main\";\n  grid-template-columns: 1fr 3fr;\n  grid-template-rows: 1fr 8fr;\n  gap: 2rem;\n  padding: 1rem 3rem;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.sidebar {\n  grid-area: sidebar;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 1rem;\n}\n\n/* Main content grid: hero section and insights + forecast below */\nmain {\n  grid-area: main;\n  display: grid;\n  grid-template-areas:\n    \"hero extras\"\n    \"forecast forecast\";\n  grid-template-rows: 2fr 1fr;\n  grid-template-columns: 2fr minmax(280px, 1fr);\n  gap: 1rem;\n}\n\n.weather-hero {\n  grid-area: hero;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n}\n\n/* Secondary insights panel (wind + astronomy modules) */\n.insight-cards {\n  grid-area: extras;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding: 0 1rem;\n}\n\n/* Bottom forecast panel */\n.forecast {\n  grid-area: forecast;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
